import React from 'react';

function APIKeysContent() {
  return (
    <>
      <p>Common questions about using API keys with RepoPrompt.</p>
      <h3>Security</h3>
      <p>Your API keys are stored securely on your local machine. They are never transmitted anywhere except directly to the respective API provider during requests.</p>
      <h3>Adding/Removing Keys</h3>
      <p>Manage your API keys in the RepoPrompt settings panel.</p>
      <h3>Multiple Keys</h3>
      <p>You can add keys for multiple supported API providers.</p>
    </>
  );
}

export default APIKeysContent;